function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QSlideTransition from '../slide-transition/QSlideTransition.js';
import StepHeader from './StepHeader.js';
import { PanelChildMixin } from '../../mixins/panel.js';
import { slot } from '../../utils/slot.js';
var StepWrapper = Vue.extend({
  name: 'QStepWrapper',
  render: function render(h) {
    return h('div', {
      staticClass: 'q-stepper__step-content'
    }, [h('div', {
      staticClass: 'q-stepper__step-inner'
    }, slot(this, 'default'))]);
  }
});
export default Vue.extend({
  name: 'QStep',
  inject: {
    stepper: {
      "default": function _default() {
        console.error('QStep needs to be child of QStepper');
      }
    }
  },
  mixins: [PanelChildMixin],
  props: {
    icon: String,
    color: String,
    title: {
      type: String,
      required: true
    },
    caption: String,
    prefix: [String, Number],
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String,
    headerNav: {
      type: Boolean,
      "default": true
    },
    done: Boolean,
    error: Boolean
  },
  computed: {
    isActive: function isActive() {
      return this.stepper.value === this.name;
    },
    onEvents: function onEvents() {
      return this.isActive !== true || this.stepper.vertical !== true || this.$q.platform.is.ios !== true && this.$q.platform.is.chrome === true ? _objectSpread({}, this.qListeners) : _objectSpread(_objectSpread({}, this.qListeners), {}, {
        scroll: this.__keepScroll
      });
    }
  },
  methods: {
    __keepScroll: function __keepScroll(ev) {
      var target = ev.target;

      if (target.scrollTop > 0) {
        target.scrollTop = 0;
      }

      this.qListeners.scroll !== void 0 && this.qListeners.scroll(ev);
    }
  },
  render: function render(h) {
    var vertical = this.stepper.vertical;
    var content = vertical === true && this.stepper.keepAlive === true ? h('keep-alive', this.isActive === true ? [h(StepWrapper, {
      key: this.name
    }, slot(this, 'default'))] : void 0) : vertical !== true || this.isActive === true ? StepWrapper.options.render.call(this, h) : void 0;
    return h('div', {
      staticClass: 'q-stepper__step',
      on: this.onEvents
    }, vertical === true ? [h(StepHeader, {
      props: {
        stepper: this.stepper,
        step: this
      }
    }), this.stepper.animated === true ? h(QSlideTransition, [content]) : content] : [content]);
  }
});